"use strict";

export function draw_lead_log_tab(lead_log) {
	if (!lead_log) {
		console.error("Error: lead_log is not found or is null");
		return;
	}

	const formatted_log = lead_log.replace(
		/\[([^\]]+)\]/g,
		'<b>[$1]</b>'
	);

	$('#lead_log').html(formatted_log);
}
